import axios from 'axios';
import { Commentary } from '../../../../commentary/commentary.types';

export function getCommentariesUrls(
  docId: string,
  query: string,
): Promise<{ data: Array<Commentary> }> {
  return axios.get(`/api/decisions/${docId}/commentaries`, {
    params: {
      q: query,
    },
  });
}
